import { render, staticRenderFns } from "./ResourceHeaderTemplate.vue?vue&type=template&id=1ebf3e59"
import script from "./ResourceHeaderTemplate.vue?vue&type=script&lang=ts"
export * from "./ResourceHeaderTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ResourceHeaderTemplate.vue?vue&type=style&index=0&id=1ebf3e59&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports